const whiteApiList = [
  'truck-return-register/pageQuery',
  'transport-task-manager/page',
  'transportLine/page',
  'pickup-dispatch-task-manager/page',
  'order-manager/order/page',
  'transport-order-manager/page',
  'login',
  'files/imageUpload'
]

export default whiteApiList
